/** Public square Qixit mark for MFA screens (also used in otpauth image=). */
export const QIXIT_AUTHENTICATOR_ICON_URL = 'https://mail.qixit.com/qixit-authenticator.png';

/** Prefer same-origin public asset when available; fall back to production CDN URL. */
export function resolveQixitAuthenticatorIconUrl(preferSameOrigin = true): string {
  if (preferSameOrigin && typeof window !== 'undefined') {
    return '/qixit-authenticator.png';
  }
  return QIXIT_AUTHENTICATOR_ICON_URL;
}
